<template>
  <div v-if="screenData" class="sub-view analysis-zone">
    <div :class="['sub-view-wrapper', activeAside && 'opened']">
      <div class="sub-view-gabarit">
        <div class="header-box">
          <h4>{{ $t('sections.transit') }}</h4>
        </div>
        <Filters />
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.transitCollaboratorsByTransitTime') }}</h5>
          </template>
          <template #body>
            <CollaboratorsByTransitTime :data="screenData" />
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.transitCollaboratorsByTransitTimePercent') }}</h5>
          </template>
          <template #body>
            <CollaboratorsByTransitTime :data="screenData" :percentMode="true" />
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.transitCollaboratorsByTransitTimeChart') }}</h5>
          </template>
          <template #action>
            <div class="action-button" @click="advencedMode = !advencedMode">
              {{ advencedMode ? $t('report.hideTransitCollaboratorsByTransitTimeChartMode') : $t('report.showTransitCollaboratorsByTransitTimeChartMode') }}
            </div>
          </template>
          <template #body>
            <CollaboratorsByTransitTimeChart :data="screenData" :advencedMode="advencedMode" :sensitiveCaseDuration="study.sensitive_case_duration" />
            <div class="table-button-container">
              <div class="table-divider" :class="{ hidden: !showTable }"></div>
              <div class="table-button" @click="showTableDetails">
                {{ showTable ? $t('report.hideTransitCollaboratorsByTransitTimeTable') : $t('report.showTransitCollaboratorsByTransitTimeTable') }}
              </div>
              <div class="table-divider" :class="{ hidden: !showTable }"></div>
            </div>
            <CollaboratorsByTransitTimeTable v-if="showTable" :data="screenData" :advencedMode="advencedMode" />
          </template>
        </AnalysisSection>
        <AnalysisSection>
          <template #header>
            <h5>{{ $t('report.transitTimeByOrigin') }}</h5>
          </template>
          <template #body>
            <TransitTimeByOrigin :data="screenData" />
          </template>
        </AnalysisSection>
      </div>
      <FooterSection v-if="isDesktop" class="footer-section" />
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Analysis from './AnalysisMixin';
import CollaboratorsByTransitTime from '@/components/Analysis/Transit/CollaboratorsByTransitTime';
import CollaboratorsByTransitTimeChart from '@/components/Analysis/Transit/CollaboratorsByTransitTimeChart';
import CollaboratorsByTransitTimeTable from '@/components/Analysis/Transit/CollaboratorsByTransitTimeTable';
import TransitTimeByOrigin from '@/components/Analysis/Transit/TransitTimeByOrigin';
import FooterSection from '@/components/Footer';

export default {
  components: {
    CollaboratorsByTransitTime,
    CollaboratorsByTransitTimeChart,
    CollaboratorsByTransitTimeTable,
    TransitTimeByOrigin,
    FooterSection,
  },

  mixins: [Analysis],

  data() {
    return {
      advencedMode: false,
      showTable: false,
    };
  },

  computed: {
    ...mapGetters({
      isDesktop: 'isDesktop',
      study: 'study',
    }),
  },

  methods: {
    showTableDetails() {
      this.showTable = !this.showTable;
    },
  },
};
</script>

<style lang="scss" scoped>
@use '@/styles/colors.scss';

.table-button-container {
  display: flex;
  align-items: center;
  margin: 0 auto 24px;

  .table-divider {
    height: 1px;
    width: 100%;
    background: colors.$clear-border-color;
    margin: 0 8px;
    transition: 0.2s;

    &.hidden {
      opacity: 0;
    }
  }

  .table-button {
    padding: 4px 16px;
    border-radius: 16px;
    border: 1px solid colors.$near-dark-color;

    flex-shrink: 0;
    color: colors.$near-dark-color;
    margin: 0 auto;
    text-align: center;
    cursor: pointer;
    transition: 0.2s;

    &:hover {
      opacity: 0.8;
    }

    &:active {
      opacity: 0.6;
    }
  }
}
</style>
